module.exports = __webpack_public_path__ + "assets/images/3-BOzlEw0.jpg";